module.exports = __webpack_public_path__ + "img/fail-icon.967af154.png";